module.exports = __webpack_public_path__ + "static/media/pc-zhifubao.25952f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pc-zhifubao.png
// module id = 2709
// module chunks = 2